export const AppColors = {
  primary: '#26BAAE',
  secondary: '',
  white: 'white',
  white50: 'rgba(255, 255, 255, 0.5)',
  white67: 'rgba(255, 255, 255, 0.67)',
  border: '#F1F1F1',
  backgroundColor: '#F9F9F9',
  gray: '#757575',
  lightGray: '#E2E2E2',
  lightGray2: '#E0E0E0',
  lighterGray: '#CACACA',
  yellow: '#FFC043',
  orange: '#F59E0B',
  darkerOrange: '#EA580C',
  orange5: 'rgba(245, 158, 11, 0.05)',
  darkOrange: '#9B6811',
  blue: '#276EF1',
  lightBlue: '#DCE7FB',
  red: '#D11B59',
  lightRed: '#FED7D2',
  shadowColor: 'rgba(0, 0, 0, 0.1)',
  green: '#05944F',
  black: 'rgb(0,0,0)',
  black50: 'rgba(0,0,0,0.5)',
  black80: 'rgba(0,0,0,0.8)',
  // tabbarBackground: 'rgba(186, 186, 186, 0.25)',
  tabbarBackground: '#189388',
  darkGreen: '#16766E',
  tripStatus: {
    // upcoming: {
    //   color: 'white',
    //   backgroundColor: '#26BAAE',
    // },
    // completed: {
    //   color: 'white',
    //   backgroundColor: '#FFC043',
    // },
    // Completed: {
    //   color: 'white',
    //   backgroundColor: '#FFC043',
    // },
    Departed: {
      color: 'white',
      // backgroundColor: '#26BAAE',
      backgroundColor: '#FFC043',
    },
    Canceled: {
      color: 'white',
      backgroundColor: '#D11B59',
    },
    Upcoming: {
      color: 'white',
      backgroundColor: '#10B981',
    },
  },
  ratingBackground: '#FBFBFB',
  ratingBorder: '#F3F4F6',
  rateUnselect: '#DEE0E4',
  seatAvailability: {
    available: '#DEE0E4',
    selected: '#26BAAE',
    booked: '#D11B59',
    busy: '#FBBF24',
  },
  rateSeparateColor: {
    0: '#E0E0E0',
    1: '#7F1D1D',
    2: '#7C2D12',
    3: '#78350F',
    4: '#064E3B',
    5: '#134E4A',
  } as any,
  rateColor: {
    0: 'transparent',
    1: '#B91C1C',
    2: '#F97316',
    3: '#FBBF24',
    4: '#10B981',
    5: '#26BAAE',
  } as any,
};

export const CustomShadow = {
  shadowColor: AppColors.shadowColor,
  // shadowColor: AppColors.red,
  shadowRadius: 10, // Blur
  shadowOpacity: 1,
  shadowOffset: { width: 2, height: 2 },
};

export const CustomButtonShadow = {
  shadowColor: 'rgba(0, 0, 0, 0.18)',
  shadowRadius: 10,
  shadowOpacity: 1,
  shadowOffset: { width: 1, height: 1 },
};
